import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import StickyNote from '../components/common/StickyNote';
import KidCard from '../components/dashboard/KidCard';
import TimelineWidget from '../components/dashboard/TimelineWidget';
import MealPlanWidget from '../components/dashboard/MealPlanWidget';

const { FiSun, FiMapPin, FiAlertCircle, FiArrowRight } = FiIcons;

const MOCK_KIDS = [
  { 
    id: 1, 
    name: 'Leo', 
    age: 8, 
    location: 'School (Room 4B)', 
    status: 'In Class', 
    avatar: 'https://images.unsplash.com/photo-1618678900888-eb9545932560?w=200&h=200&fit=crop&q=80', 
    pickup: 'Mom @ 3:15 PM' 
  },
  { 
    id: 2, 
    name: 'Mia', 
    age: 5, 
    location: 'Daycare', 
    status: 'Nap Time', 
    avatar: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=200&h=200&fit=crop&q=80', 
    pickup: 'Dad @ 4:30 PM' 
  },
];

const MOCK_NOTES = [
  { id: 1, text: 'Remember to sign Leo\'s permission slip for the zoo trip!', type: 'urgent', author: 'Mom' },
  { id: 2, text: 'Buy more juice boxes before Friday.', type: 'normal', author: 'Dad' },
  { id: 3, text: 'Soccer snacks rotation: our turn next week!', type: 'normal', author: 'Coach Mike' },
];

export default function Dashboard() {
  return (
    <div className="space-y-8">
      <header className="flex justify-between items-end">
        <div>
          <h2 className="text-4xl font-black text-[#1a365d] tracking-tight">Command Wall</h2>
          <p className="text-slate-500 mt-2 flex items-center gap-2 font-medium">
            <SafeIcon icon={FiSun} className="text-yellow-500 text-xl" /> 
            Good morning! It's going to be a busy Tuesday.
          </p>
        </div>
        <div className="hidden lg:block bg-white px-4 py-2 rounded-2xl shadow-sm border border-slate-200">
           <div className="flex items-center gap-3">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="text-xs font-bold text-slate-600 uppercase tracking-widest">Family Sync Active</span>
           </div>
        </div>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        {/* Left Column: Kids & Notes */}
        <div className="lg:col-span-8 space-y-8">
          {/* Kid Status Tracker */}
          <section>
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-black text-slate-800 flex items-center gap-3">
                <SafeIcon icon={FiMapPin} className="text-[#1a365d]" />
                Where is Everyone?
              </h3>
              <button className="text-xs font-bold text-[#1a365d] hover:underline flex items-center gap-1 uppercase tracking-widest">
                Real-time Map <SafeIcon icon={FiArrowRight} />
              </button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {MOCK_KIDS.map(kid => (
                <KidCard key={kid.id} kid={kid} />
              ))}
            </div>
          </section>

          {/* Sticky Notes Area (Fridge Vibe) */}
          <section className="bg-slate-200/30 rounded-[2.5rem] p-8 md:p-10 border-2 border-white shadow-inner relative overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 bg-white/40 rounded-full -mr-20 -mt-20 blur-3xl"></div>
            <div className="flex items-center justify-between mb-8 relative z-10">
              <h3 className="text-xl font-black text-slate-800 flex items-center gap-3">
                <SafeIcon icon={FiAlertCircle} className="text-yellow-600" />
                Fridge Notes
              </h3>
              <span className="px-3 py-1 bg-yellow-300/20 text-yellow-700 text-[10px] font-black uppercase rounded-full border border-yellow-200">
                {MOCK_NOTES.length} New Pins
              </span>
            </div>
            <div className="flex flex-wrap gap-8 relative z-10">
              {MOCK_NOTES.map((note, idx) => (
                <StickyNote key={note.id} note={note} index={idx} />
              ))}
            </div>
          </section>
        </div>

        {/* Right Column: Timeline & Meals */}
        <div className="lg:col-span-4 space-y-8">
          <TimelineWidget />
          <MealPlanWidget />
          
          <div className="bg-gradient-to-br from-yellow-300 to-yellow-400 p-6 rounded-3xl shadow-lg relative overflow-hidden group cursor-pointer active:scale-95 transition-transform">
             <div className="absolute -right-4 -bottom-4 w-24 h-24 bg-white/20 rounded-full group-hover:scale-150 transition-transform duration-700"></div>
             <h4 className="font-black text-[#1a365d] mb-1">Upgrade to Pro</h4>
             <p className="text-xs text-[#1a365d]/80 font-medium leading-tight">Unlock AI School Portal Sync and unlimited family members.</p>
          </div>
        </div>
      </div>
    </div>
  );
}